/* eslint-disable eqeqeq */
/* eslint-disable no-bitwise */
import axios from 'axios'
import { verifyAppTokenValid, expiredAppTokenValid } from '@console/utils/index'

const Global: any = global

interface DeveloperCert {
  developerTag: Array<string>
  contactAddress: string // 联系地址
  contactMailbox: string // 联系邮箱
  contactName?: string // 联系人姓名
  contactNumber?: string // 联系电话
  name: string // '企业全称' | '真实姓名' | '机构团体'
  number?: string // 证件号码
  registeredAddress?: string // 注册地址
  state: 0 | 1 | 2 // 0:企业 1:个人 2:其他
  userId: string // 用户 ID
  certificates: Array<string> // 证书照片
  certifyType?: number
  integrationPurpose?: string
}

interface ILoginOut {
  login_token: string
}

export interface IUpdateUserInfo {
  iconUrl?: string // 头像 url
  nickName?: string // 昵称，长度 1-20
  userIntroduction?: string // 个人简介，长度 1-50
}

interface ContactUs {
  contactInformation: string
  createTime: number
  remarks: string
}

function changeParams(params: any) {
  let spliceParams = ''
  for (const key in params) {
    if (spliceParams !== '') {
      spliceParams = `${spliceParams}&${key}=${params[key]}`
    } else {
      spliceParams = `${key}=${params[key]}`
    }
  }
  return encodeURI(spliceParams)
}

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

function handleResponse(response: any) {
  return response.then((res: any) => {
    return new Promise((resolve) => {
      const { status } = res
      if (status === 401) {
        expiredAppTokenValid()
      } else {
        resolve(res)
      }
    })
  })
}

// 退出登录
export function loginOut(params: ILoginOut) {
  const data = changeParams(params)
  return axios(`${Global.hostConfig.account}v1/client/logout`, {
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 开发者认证(需要传 token )
export function submitDeveloperCert(params: DeveloperCert, apptoken: string) {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  const response = axios(`${Global.hostConfig.zuul}v2/developer`, {
    method: 'POST',
    data: params,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      appname: 'com.huami.webapp',
      appVersion: '4.3.0',
      Apptoken: apptoken,
      appPlatform: '',
      Authorization: '',
      'X-Request-Id': guid()
    },
    validateStatus() {
      return true
    }
  })

  return handleResponse(response)
}

// 获取支付宝身份验证结果(需要传 token )
export function queryDeveloperCertResult(apptoken: string) {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  return axios(`${Global.hostConfig.zuul}v2/developer/certified`, {
    method: 'GET',
    data: 'params',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      appname: 'com.huami.webapp',
      appVersion: '4.3.0',
      Apptoken: apptoken,
      appPlatform: '',
      Authorization: '',
      'X-Request-Id': guid()
    }
  })
}

// 获取用户基本信息
export function getUserInfo(userid: string, apptoken: string) {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  const response = axios(`${Global.hostConfig.userInfoHost}users/${userid}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      appname: 'com.xiaomi.hm.health',
      // appname: 'com.huami.webapp',
      apptoken,
      Accept: '*/*'
    },
    validateStatus() {
      return true
    }
  })

  return handleResponse(response)
}

// 获取用户注册地信息
export function userRegistration(userid: string, apptoken: string) {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  const response = axios(`${Global.hostConfig.account}admin/users/${userid}/profile`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apptoken}`,
      'X-Request-Id': guid()
    },
    validateStatus() {
      return true
    }
  })

  return handleResponse(response)
}

// 保存用户信息
export function saveUserInfo(userid: string, apptoken: string, params: IUpdateUserInfo) {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  return axios(`${Global.hostConfig.userInfoHost}users`, {
    method: 'POST',
    data: { ...params, userId: userid },
    headers: {
      'Content-Type': 'application/json',
      apptoken,
      Accept: '*/*'
    },
    timeout: 5000,
    validateStatus() {
      return true
    }
  })
}

// 更新用户信息
export function updateUserInfo(userid: string, apptoken: string, params: IUpdateUserInfo) {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  return axios(`${Global.hostConfig.userInfoHost}users/${userid}`, {
    method: 'PUT',
    data: { ...params, userId: userid },
    headers: {
      'Content-Type': 'application/json',
      appname: 'com.xiaomi.hm.health',
      apptoken,
      Accept: '*/*'
    },
    timeout: 5000,
    validateStatus() {
      return true
    }
  })
}

// 修改开发者信息
export function updateDeveloperInfo(displayName: string, apptoken: string) {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  return axios(`${Global.hostConfig.zuul}v2/developer/modify`, {
    method: 'PUT',
    data: { displayName },
    headers: {
      'Content-Type': 'application/json',
      apptoken,
      Accept: '*/*'
    },
    timeout: 5000,
    validateStatus() {
      return true
    }
  })
}

// 上传文件 https://apihub.huami.com/project/181/interface/api/14465
export function getFileAccessURIs(userid: string, apptoken: string, fileName: string, fileType = 'PICTURE', appName = 'com.xiaomi.hm.health') {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  return axios(`${Global.hostConfig.userInfoHost}users/${userid}/apps/${appName}/fileAccessURIs`, {
    method: 'POST',
    data: { fileName, fileType },
    headers: {
      'Content-Type': 'application/json',
      appname: 'com.xiaomi.hm.health',
      apptoken,
      Accept: '*/*'
    },
    timeout: 5000,
    validateStatus() {
      return true
    }
  })
}

// 根据 putURI 上传文件
export function uploadByPutURI(putURI: string, file: any) {
  return axios(putURI, {
    method: 'PUT',
    data: file,
    headers: {
      'Content-Type': file.type,
      Accept: '*/*'
    }
  })
}

// 用户反馈
export function contactUs(params: ContactUs, apptoken: string) {
  if (!apptoken) {
    verifyAppTokenValid()
  }
  return axios({
    url: `${Global.hostConfig.zuul}v2/user/feedback`,
    method: 'POST',
    data: params,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      apptoken
    },
    validateStatus() {
      return true
    }
  })
}
